import { WellnessWheelArcProps } from "../types";

export default function MentalHealthCategoryArc({
  arcColorFill,
}: WellnessWheelArcProps) {
  return (
    <path
      d="M29.375 137.418C29.375 107.07 41.3362 79.58 60.698 59.6152"
      stroke={arcColorFill}
      strokeWidth="50.521"
      strokeLinecap="round"
      style={{
        strokeDasharray: 1000,
        strokeDashoffset: 1000,
        animation: "drawArc 2s ease-out 2s forwards",
      }}
    />
  );
}
